export const GET_PROMO_RATING_SUCCESS = 'GET_PROMO_RATING_SUCCESS'

export const CHANGE_SELECTED_RATING_TYPE = 'CHANGE_SELECTED_RATING_TYPE'
